export default __webpack_public_path__ + "static/cybersecurity-think-paper-3-cbedff65c3d1d042bc1265cfc5719f33.jpg";